/** ============================================================= *
 *  ---------------------- IMPORT - START ----------------------- *
 *  ============================================================= */
import 'what-input'
import jQuery from 'jquery'
import Foundation from 'foundation-sites'
import intlTelInput from 'intl-tel-input'
import Swiper from 'swiper'
import { Navigation, Pagination, Grid, FreeMode, Autoplay, EffectCoverflow } from 'swiper/modules'
import { setHrefs } from './functions/data-hrefs'
import { initEqualizeContent } from './functions/equalizer'
import { initTelephoneInput } from './functions/intl-tel-input'
import { initDatepickerInput } from './functions/datepicker'
import { enableNegativeMargins } from './functions/negative-margins'
import { mapStyles } from './functions/map-styles'
// import { enableCallrailTracking } from './functions/callrail'
/** ============================================================= *
 *  ----------------------- IMPORT - END ------------------------ *
 *  ============================================================= */



/** ============================================================= *
 *  ------------ GLOBAL VARIABLES DECLARATION - START ----------- *
 *  ============================================================= */
const THEME_FOLDER = "../wp-content/themes/codesm_v2"
const PHONE_FIELD = ".codesm-phone-field"
const DATEPICKER_FIELD = ".codesm-datepicker-field"
const DATEPICKER_FORMAT = "mm/dd/yyyy"
const EQUALIZE_CONTENT = ".codesm-equalize-content"

Foundation.addToJquery(jQuery)
Swiper.use([Navigation, Pagination, Grid, FreeMode, Autoplay, EffectCoverflow])
window.intlTelInput = intlTelInput
window.setHrefs = setHrefs
window.initEqualizeContent = initEqualizeContent
window.initTelephoneInput = initTelephoneInput
window.initDatepickerInput = initDatepickerInput
window.enableNegativeMargins = enableNegativeMargins
window.mapStyles = mapStyles
// window.enableCallrailTracking = enableCallrailTracking
/** ============================================================= *
 *  ------------- GLOBAL VARIABLES DECLARATION - END ------------ *
 *  ============================================================= */

function copyToClipboard(text)
{
	var brRegex = /<br\s*[\/]?>/gi;

	var $tempDiv = jQuery("<div>");
	var $tempInput = jQuery("<textarea>");
	
	jQuery("body").append($tempDiv);
	jQuery("body").append($tempInput);
	
	jQuery($tempDiv).html(text);
	$tempInput.val(jQuery($tempDiv).html().replace(brRegex, "\r\n")).select();
	document.execCommand("copy");
	$tempDiv.remove();
	$tempInput.remove();
}

jQuery(document).ready(function(){
	jQuery(document).foundation();
	triggerThemeFunctions();

	// if(jQuery('#toggleImage').length)
	// {
	// 	jQuery('#toggleImage').click(function(){
	// 		jQuery('#hiddenContent').slideToggle();
	// 		jQuery(this).toggleClass('clicked')
	// 	});
	// }

	jQuery(document).on('click','[data-toggle]',function(){
		var target = jQuery(this).data('toggle');
		jQuery(target).slideToggle();
		jQuery(this).toggleClass('clicked')
		
	});
	
	

	// COPY TO CLIPBOARD BLOCKQUOTES
	jQuery('.resource-blockquote').each(function(){
		var element = jQuery(this).find('.resource-blockquote-copy-to-clipboard');
		var text = jQuery(element).data('clipboard');

		jQuery(element).on('click', function(){
			copyToClipboard(text);
			alert("Copied to Clipboard.");
		});
	});


	// PRODUCTS NAVIGATION DROPDOWN
	jQuery('#products-navigation-dropdown').animate({width:'300px'},300);
	jQuery('#products-navigation-dropdown').css("display","");

	jQuery(document).on({
		click: function() {
			if(!jQuery('#products-column-trigger').hasClass('open')) {
				jQuery('#products-column-trigger').addClass('open');
				jQuery('#products-navigation-dropdown').animate({width:'600px'},{
					easing: 'swing',
					duration: 300,
					complete: function() {
						jQuery('#products-column').fadeIn(300);
					}
				});
			} else {
				jQuery('#products-column-trigger').removeClass('open');
				jQuery('#products-column').fadeOut(300, function() {
					jQuery('#products-navigation-dropdown').animate({width:'300px'},{
						easing: 'swing',
						duration: 300
					});
				});
			}
		}
	}, '#products-column-trigger');

	jQuery('#products-column-trigger').hover(
		function() {
			if(!jQuery('#products-column-trigger').hasClass('open')) {
				jQuery('#products-column-trigger').addClass('open');
				jQuery('#products-navigation-dropdown').animate({width:'600px'},{
					easing: 'swing',
					duration: 300,
					complete: function() {
						jQuery('#products-column').fadeIn(300);
					}
				});
			}
		}, 
		function() {
			if(!jQuery('#products-column-trigger').hasClass('open')) {
				jQuery('#products-column-trigger').removeClass('open');
				jQuery('#products-column').fadeOut(300, function() {
					jQuery('#products-navigation-dropdown').animate({width:'300px'},{
						easing: 'swing',
						duration: 300
					});
				});
			}
		}
	);

	var swiper = new Swiper('#timeline-swiper .swiper-container', {
		
		direction: 'horizontal',
		grabCursor: true,
		slidesPerView: 1,
		watchSlidesProgress: true,
		observeParents: true,
		
		pagination: {
			el: '#timeline-swiper .swiper-pagination',
			clickable: true,
			dynamicBullets: true,
			dynamicMainBullets: 1,
		},
		
		breakpoints: {
			640: {
				slidesPerView: 1,
				
			},
			1024: {
				slidesPerView: 2,
				
			},
			1200: {
				slidesPerView: 3,
				
			},
			1440: {
				slidesPerView: 4,
				
			}
		},
		on: {
			init: function () {
				setTimeout(function() {
					window.dispatchEvent(new Event('resize'));
				}, 500);
			},
		},
	  }); 

	// TEAM MEMBERS
	var teamSwiper = new Swiper('#team-members .swiper-container', {
		direction: 'horizontal',
		spaceBetween: 20,
		slidesPerView: 3,
		watchSlidesProgress: true,
		observeParents: true,
		loop: true,
		loopAdditionalSlides: 6,
		pagination: false,
		grabCursor: true,
		// pagination: {
		// 	el: '#team-members .swiper-pagination',
		// 	clickable: true,
		// 	dynamicBullets: true,
		// 	dynamicMainBullets: 1,
		// },
		breakpoints: {
			640: {
				slidesPerView: 3,
				spaceBetween: 20,
			},
			1024: {
				slidesPerView: 4,
				spaceBetween: 30,
			},
			1200: {
				slidesPerView: 5,
				spaceBetween: 30,
			},
			1440: {
				slidesPerView: 8,
				spaceBetween: 30,
			}
		},
		// on: {
		// 	init: function () {
		// 		setTimeout(function() {
		// 			window.dispatchEvent(new Event('resize'));
		// 		}, 500);
		// 	},
		// },
	});

	// TESTIMONIALS
	var testimonialSwiper = new Swiper('#testimonials .swiper-container',{
		direction: 'horizontal',
		slidesPerView: 1,
		watchSlidesProgress: true,
		observeParents: true,
		pagination: {
			el: '#testimonials .swiper-pagination',
			clickable: true,
			dynamicBullets: true,
			dynamicMainBullets: 1,
		},
		breakpoints: {
			640: {
				slidesPerView: 1,
			},
			1024: {
				slidesPerView: 1,
				spaceBetween: 30,
			},
			1200: {
				slidesPerView: 1,
				spaceBetween: 30,
			},
		  	1440: {
				slidesPerView: 1,
				spaceBetween: 30,
			},
		},
		on: {
			init: function () {
				setTimeout(function() {
					window.dispatchEvent(new Event('resize'));
				}, 500);
			},
		},
	});

	// SERVICES
	var serviceSwiper = new Swiper('#services .swiper-container', {
		direction: 'horizontal',
		spaceBetween: 20,
		slidesPerView: 1,
		slidesPerColumn: 1,
		watchSlidesProgress: true,
		observeParents: true,
		pagination: {
			el: '#services .swiper-pagination',
			clickable: true,
			dynamicBullets: true,
			dynamicMainBullets: 1,
		},
		breakpoints: {
			640: {
				slidesPerView: 2,
				spaceBetween: 20,
			},
			1024: {
				slidesPerView: 3,
				spaceBetween: 30,
			},
			1200: {
				slidesPerView: 3,
				spaceBetween: 30,
			},
			1440: {
				slidesPerView: 4,
				spaceBetween: 30,
				grid: {
					fill: 'row',
					rows: 2,
				},
			}
		},
		on: {
			init: function () {
				setTimeout(function() {
					window.dispatchEvent(new Event('resize'));
				}, 500);
			},
		},
	});

	// SERVICES
	var portfolioServiceSwiper = new Swiper('#portfolio-services .swiper-container', {
		direction: 'horizontal',
		spaceBetween: 20,
		slidesPerView: 1,
		slidesPerColumn: 1,
		watchSlidesProgress: true,
		observeParents: true,
		pagination: {
			el: '#portfolio-services .swiper-pagination',
			clickable: true,
			dynamicBullets: true,
			dynamicMainBullets: 1,
		},
		breakpoints: {
			640: {
				slidesPerView: 2,
				slidesPerColumn: 1,
				spaceBetween: 20,
			},
			1024: {
				slidesPerView: 3,
				slidesPerColumn: 1,
				spaceBetween: 30,
			},
			1200: {
				slidesPerView: 3,
				slidesPerColumn: 1,
				spaceBetween: 30,
			},
			1440: {
				slidesPerView: 4,
				spaceBetween: 30,
				freeMode: {
					enabled: true,
					sticky: true,
				},
			}
		},
		on: {
			init: function () {
				setTimeout(function() {
					window.dispatchEvent(new Event('resize'));
				}, 500);
			},
		},
	});


	// CLIENT LOGOS
	var clientLogoSwiper = new Swiper('#client-logos .swiper-container', {
		direction: 'horizontal',
		slidesPerView: 2,
		spaceBetween: 20,
		grid: {
			fill: 'row',
			rows: 2,
		},
		watchSlidesProgress: true,
		observeParents: true,
		pagination: {
			el: '#client-logos .swiper-pagination',
			clickable: true,
			dynamicBullets: true,
			dynamicMainBullets: 1,
		},
		breakpoints: {
			640: {
				slidesPerView: 3,
				spaceBetween: 20,
			},
			1024: {
				slidesPerView: 3,
				spaceBetween: 30,
			},
			1200: {
				slidesPerView: 4,
				spaceBetween: 30,
			},
			1440: {
				slidesPerView: 5,
				spaceBetween: 30,
				// freeMode: {
				// 	enabled: true,
				// 	sticky: true,
				// },
			}
		},
		on: {
			init: function () {
				setTimeout(function() {
					window.dispatchEvent(new Event('resize'));
				}, 500);
			},
		},
	});

	// CLIENT LOGOS
	var clientLogoSingleRowSwiper = new Swiper('#client-logos-single-row .swiper-container', {
		direction: 'horizontal',
		spaceBetween: 20,
		slidesPerView: 1,
		// watchSlidesVisibility: true,
		watchSlidesProgress: true,
		// observer: true,
		// observeParents: true,
		pagination: {
			el: '#client-logos-single-row .swiper-pagination',
			clickable: true,
			dynamicBullets: true,
			dynamicMainBullets: 1,
		},
		breakpoints: {
			640: {
				slidesPerView: 3,
				spaceBetween: 20,
			},
			1024: {
				slidesPerView: 3,
				spaceBetween: 30,
			},
			1200: {
				slidesPerView: 4,
				spaceBetween: 30,
			},
			1440: {
				// slidesPerView: 'auto',
				slidesPerView: 5,
				spaceBetween: 30,
				// freeMode: {
				// 	enabled: true,
				// 	sticky: true,
				// },
			}
		},
		on: {
			init: function () {
				setTimeout(function() {
					window.dispatchEvent(new Event('resize'));
				}, 500);
			},
		},
	});


	// NEW MAAS PAGE SERVICES
	var MaasServicesSwiper = new Swiper('#new-maas-swiper .swiper-container', {
		direction: 'horizontal',
		spaceBetween: 20,
		slidesPerView: 1,
		slidesPerColumn: 1,
		initialSlide: 1,
		watchSlidesProgress: true,
		observeParents: true,
		pagination: {
			el: '#new-maas-swiper .swiper-pagination',
			clickable: true,
			dynamicBullets: true,
			dynamicMainBullets: 1,
		},
		breakpoints: {
			640: {
				slidesPerView: 1,
				spaceBetween: 20,
			},
			1024: {
				slidesPerView: 1,
				spaceBetween: 30,
			},
			1200: {
				slidesPerView: 1,
				spaceBetween: 30,
			},
			1440: {
				slidesPerView: 1,
				spaceBetween: 30,
			}
		},
		on: {
			init: function () {
				setTimeout(function() {
					window.dispatchEvent(new Event('resize'));
				}, 500);
			},
		},
	});

	jQuery('[id^="case-study-swiper"] .swiper-container').each(function (index, swiperEl) {
		const containerId = jQuery(swiperEl).closest('[id^="case-study-swiper"]').attr('id');

		new Swiper(swiperEl, {
			direction: 'horizontal',
			spaceBetween: 20,
			slidesPerView: 1,
			slidesPerColumn: 1,
			initialSlide: 1,
			watchSlidesProgress: true,
			observeParents: true,
			effect: "coverflow",
			coverflowEffect: {
				rotate: 10,
				stretch: 0,
				depth: 100,
				modifier: 3,
				slideShadows: false,
			},
			pagination: {
				el: '#' + containerId + ' .swiper-pagination',
				clickable: true,
				dynamicBullets: true,
				dynamicMainBullets: 1,
			},
			breakpoints: {
				640: {
					slidesPerView: 1,
					spaceBetween: 20,
				},
				1024: {
					slidesPerView: 1,
					spaceBetween: 30,
				},
				1200: {
					slidesPerView: 1,
					spaceBetween: 30,
				},
				1440: {
					slidesPerView: 1,
					spaceBetween: 30,
				}
			},
			on: {
				init: function () {
					setTimeout(function () {
						window.dispatchEvent(new Event('resize'));
					}, 500);
				}
			}
		});
	});

	// AI PAGE SWIPER
	var AIApplicationsSwiper = new Swiper('#ai-swiper .swiper-container', {
		direction: 'horizontal',
		spaceBetween: 20,
		slidesPerView: 1,
		slidesPerColumn: 1,
		initialSlide: 1,
		watchSlidesProgress: true,
		observeParents: true,
		pagination: {
			el: '#ai-swiper .swiper-pagination',
			clickable: true,
			dynamicBullets: true,
			dynamicMainBullets: 1,
		},
		breakpoints: {
			640: {
				slidesPerView: 1,
				spaceBetween: 20,
			},
			1024: {
				slidesPerView: 2,
				spaceBetween: 30,
			},
			1200: {
				slidesPerView: 3,
				spaceBetween: 30,
			},
			1440: {
				slidesPerView: 3,
				spaceBetween: 30,
			}
		},
		on: {
			init: function () {
				setTimeout(function() {
					window.dispatchEvent(new Event('resize'));
				}, 500);
			},
		},
	});


	// MAAS LOGO SWIPER
	var maasLogoSwiper = new Swiper('#maas-logo-swiper .swiper-container', {
		direction: 'horizontal',
		spaceBetween: 20,
		slidesPerView: 2,
		//watchSlidesProgress: true,
		//observeParents: true,
		loop: true,
		speed: 5000,
		autoplay: {
			delay: 0,
			disableOnInteraction: false,
		},
		breakpoints: {
			640: {
				slidesPerView: 2,
				spaceBetween: 20,
			},
			1024: {
				slidesPerView: 3,
				spaceBetween: 30,
			},
			1200: {
				slidesPerView: 5,
				spaceBetween: 30,
			},
			1440: {
				slidesPerView: 6,
				spaceBetween: 30,
			}
		},
		on: {
			init: function () {
				setTimeout(function() {
					window.dispatchEvent(new Event('resize'));
				}, 500);
			},
		},
	});

	// FILTER DROPDOWNS
	jQuery('.filter-dropdown').on('change', function () {
		var url = jQuery(this).val() || jQuery(this).data('href');
		if (url || window.location.href !== url) {
			window.location = url;
		}
		return false;
	});
});



/** ======= DO NOT EDIT BELOW THIS POINT UNLESS NECESSARY ======= *
 *  ----------------- THEME FUNCTIONS - START ------------------- *
 *  ======= DO NOT EDIT BELOW THIS POINT UNLESS NECESSARY ======= */
function triggerThemeFunctions()
{
	// REMOVE EMPTY P TAGS CREATED BY WP INSIDE OF ACCORDION AND ORBIT
	jQuery('.accordion p:empty, .orbit p:empty').remove();

	// ADD FLEX VIDEO TO YOUTUBE AND VIMEO EMBEDS
	jQuery(':not(.responsive-embed):not(.flex-video)>iframe[src*="youtube.com"], :not(.responsive-embed):not(.flex-video)>iframe[src*="vimeo.com"]').each(function() {
		if ( jQuery(this).innerWidth() / jQuery(this).innerHeight() > 1.5 ) {
			jQuery(this).wrap("<div class='widescreen responsive-embed'/>");
		} else {
			jQuery(this).wrap("<div class='responsive-embed'/>");
		}
	});

	// ENABLE PSEUDO ELEMENTS FOR FONT AWESOME
	window.FontAwesomeConfig = {
		searchPseudoElements: true
	};

	// DISABLE FIRST OPTION
	jQuery('select.disable-first-option').each(function(){
		jQuery(this).find('option').first().attr('disabled', 'disabled');
	});

	// HANDLE DATA-HREF
	window.setHrefs();

	// TRIGGER EQUALIZER
	window.initEqualizeContent(EQUALIZE_CONTENT);

	// INTL-TEL-INPUT
	window.initTelephoneInput(PHONE_FIELD, THEME_FOLDER);

	// ENABLE NEGATIVE MARGINS
	window.enableNegativeMargins();

	// FOUNDATION DATEPICKER
	window.initDatepickerInput(DATEPICKER_FIELD, DATEPICKER_FORMAT);

	// // ENABLE CALLRAIL TRACKING
	// window.enableCallrailTracking();
}
/** ======= DO NOT EDIT ABOVE THIS POINT UNLESS NECESSARY ======= *
 *  ------------------ THEME FUNCTIONS - END -------------------- *
 *  ======= DO NOT EDIT ABOVE THIS POINT UNLESS NECESSARY ======= */